var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.143,
    height: 13.572,
    viewBox: "0 0 27.143 13.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "low-battery",
    transform: "translate(27.143) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M13.572,4.519a1.813,1.813,0,0,0-1.805-1.805H9.5V0H4.072V2.714H1.805A1.813,1.813,0,0,0,0,4.519V17.643H13.572Z",
    transform: "translate(0)",
    fill: "rgba(204,137,137,0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M0,0V7.7A1.813,1.813,0,0,0,1.805,9.5h9.948A1.816,1.816,0,0,0,13.572,7.7V0Z",
    transform: "translate(0 17.643)",
    fill: "#de0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBattery);
export default __webpack_public_path__ + "static/media/low-battery.d25f6fb6077c626346972741e834c73a.svg";
export { ForwardRef as ReactComponent };